import Box from '@mui/joy/Box';
import Textarea from '@mui/joy/Textarea';

/** user home画面のお知らせ表示コンポーネント */
const UHInformation = () => {
    // サンプルのお知らせデータ（テスト用）
    const sampleInfo: string = 
    "2023/12/24 クリスマスイヴ\n2023/12/25 クリスマス\n2023/12/31 大晦日\n2024/01/01 お正月\n2023/12/24 クリスマスイヴ\n2023/12/25 クリスマス\n2023/12/31 大晦日\n2024/01/01 お正月\n2023/12/24 クリスマスイヴ\n2023/12/25 クリスマス";

    return (
        <Box sx={{ height: 200, paddingX: 6, paddingY: 2}}>
            <Textarea
                readOnly
                color="neutral"
                placeholder="お知らせ"
                //defaultValue={sampleInfo}
                minRows={7}
                maxRows={7}
                sx={{fontSize: 14}}
            />
        </Box>

    );
}

export default UHInformation;